// @ts-strict-ignore
import { ProjectModel } from '@project/model/project.model';
import { IOperation } from './i-operation';
import { LoadConnectionTextureProcessor } from '@3d-scene/processor/load-connection-texture.processor';
import { LabelSequenceOperation } from './label-sequence-operation';
import { Dictionary } from 'typescript-collections';
import { SelectionModel } from '@project/components/article/model/selection.model';
import { ArrayUtils } from '../../util/array-utils';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { LabelingUtils } from '@3d-scene/model3d/util/labeling-utils';
import { LabelEditorStateManager } from '@project/components/label/label-editor/service/label-editor-state.manager';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { UpdateLabelingCompressionProcessor } from '@3d-scene/processor/update-labeling-compression.processor';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';

export interface LabelEditorUndoRedoData {
  tableProviderIdHandsontableOperationsMap: Dictionary<string, any[]>;
  isUndo: boolean;
}

export class LabelEditorSequenceOperation extends LabelSequenceOperation {

  private tableProviderIdHandsontableOperationsMap: Dictionary<string, any[]>;
  private _oldSelection: any[];
  private _newSelection: any[];

  constructor(
    operations: IOperation[],
    private selectionModel: SelectionModel,
    private selectionModelService: SelectionModelService,
    private labelEditorStateManager: LabelEditorStateManager,
    connectionInfoService: ConnectionInfoService,
    containerService: ContainerService,
    labelingUtils: LabelingUtils,
    additionalOperations: IOperation[],
    tableProviderIdHandsontableOperationsMap: Dictionary<string, any[]>,
    loadTextureProcessor: LoadConnectionTextureProcessor,
    updateLabelingCompressionProcessor: UpdateLabelingCompressionProcessor,
    oldSelection: any[] = null,
    projectModel: ProjectModel = null,
    forceUpdateTextures = false
  ) {
    super(
      operations,
      additionalOperations,
      loadTextureProcessor,
      connectionInfoService,
      containerService,
      labelingUtils,
      updateLabelingCompressionProcessor,
      projectModel,
      forceUpdateTextures
    );
    this.tableProviderIdHandsontableOperationsMap = tableProviderIdHandsontableOperationsMap;
    this._oldSelection = oldSelection;
    this._newSelection = oldSelection ? this.selectionModel.selectedObjects.concat() : null;
  }

  public getOperationDescription(): string {
    return '';
  }

  public async performRedo(): Promise<void> {
    this.labelEditorStateManager.setLabelEditorUpdateState(false);
    await super.performRedo();
    const shouldRestoreSelection: boolean = !!this._newSelection && ArrayUtils.equals(this.selectionModel.selectedObjects, this._oldSelection);
    if (shouldRestoreSelection) {
      this.updateSelection(this._newSelection);
    }
    this.labelEditorStateManager.setLabelEditorUpdateState(true);
    this.dispatchCompleteMessage(false);
  }

  public async performUndo(): Promise<void> {
    this.labelEditorStateManager.setLabelEditorUpdateState(false);
    await super.performUndo();
    const shouldRestoreSelection: boolean = !!this._oldSelection && ArrayUtils.equals(this.selectionModel.selectedObjects, this._newSelection);
    if (shouldRestoreSelection) {
      this.updateSelection(this._oldSelection);
    }
    this.labelEditorStateManager.setLabelEditorUpdateState(true);
    this.dispatchCompleteMessage(true);
  }

  private updateSelection(selections: any[]): void {
    this.selectionModelService.removeAllSelections();
    selections.forEach((selection) => {
      this.selectionModelService.selectObject(selection, true, false, true);
    });
  }

  private dispatchCompleteMessage(isUndo: boolean): void {
    const data: LabelEditorUndoRedoData = {
      tableProviderIdHandsontableOperationsMap: this.tableProviderIdHandsontableOperationsMap,
      isUndo,
    };
    this.labelEditorStateManager.notifyLabelEditorUndoRedoOperationCompleted(data);
  }
}
